import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';

import {
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import {
  TripListRead,
} from 'src/common/external/bambi-api/tripsApi';
import { TripStatusBadge } from 'src/features/trip/management/TripStatusBadge';

import { getCancelReasonDisplay } from '../cancel/CancelTripModal/cancellationReasons';

export const TripStatusCellContent = ({
  trip,
}: {
  trip: TripListRead | TripRead;
}) => {
  if (trip.status === 'canceled') {
    return (
      <SimpleTooltip
        trigger={
          <div className="cursor-pointer">
            <TripStatusBadge status={trip.status} />
          </div>
        }
        content={<div>{getCancelReasonDisplay(trip.canceled_reason)}</div>}
      />
    );
  }

  return <TripStatusBadge status={trip.status} />;
};
